// A TAXONOMY ENTRY'S LABEL IN A LANGUAGE, AND WHAT A DIVIDER IS — one home,
// both ends.
//
// BRIEF 212 §4 (2026-09-26). The MCP's `taxonomy_list` answers each code with
// its label in the bound person's language, by the rule every screen reads
// labels with (`pickEntryLabelIn`) — and the brief forbids a second copy of
// that rule. So the rule moved here, from `src/utils/taxonomyMap.ts`, as a pure
// ESM module the browser imports and the server `require()`s (Node ≥ 20.19
// requires ESM from CJS directly — `server/src/lib/conflictsModule.js:45`
// reaches `coiMatch.mjs` the same way). docs/212-deploy-note.md §8.1 is the
// census that found the server without it.
//
// THIS IS AN EXTRACTION, NOT A CHANGE. `taxonomyMap.ts` keeps every export it
// had, with the types it had, over these bodies: `DIVIDER_CODE_PREFIX`,
// `isDividerCode` and `isDividerEntry` whole; `pickEntryLabelIn` keeps the one
// thing that is the browser's — the default language, read from
// `window.__lxLang` when a caller names none — and hands the rest to
// `entryLabelIn` below, which takes the language it is given. The prose that
// explains each rule (108 §6b, 110 §3a) stays where it was written.
//
// PURE: no imports, no DOM, no prisma, no `import.meta` (recordings load
// `src/lib/*.mjs` in a vm context where that is undefined).

export const DIVIDER_CODE_PREFIX = "__div__";

export function isDividerCode(code) {
  return typeof code === "string" && code.startsWith(DIVIDER_CODE_PREFIX);
}

export function isDividerEntry(e) {
  return !!(
    e &&
    ((e.meta && e.meta.divider === true) ||
      isDividerCode(e.code))
  );
}

/** The entry's label in `lang` ("fr" | "nl" | anything else reads English):
 *  the language's own column when set, else English, the legacy single
 *  label, the code — and a divider's heading or nothing, never its code. */
export function entryLabelIn(e, lang) {
  if (!e) return "";
  if (lang === "fr" && e.labelFr) return e.labelFr;
  if (lang === "nl" && e.labelNl) return e.labelNl;
  if (isDividerEntry(e)) return e.labelEn || e.label || "";
  return e.labelEn || e.label || e.code || "";
}
